"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function INC(state, key) {
    if (!state.locked) {
        state[key]++;
    }
}
exports.INC = INC;
// decrement the chosen persons type by one
function DEC(state, key) {
    if (!state.locked) {
        state[key]--;
    }
}
exports.DEC = DEC;
// directly set all persons values
function SET_ALL(state, groups) {
    state.adults = groups.A;
    state.juveniles = groups.J;
    state.children = groups.C;
}
exports.SET_ALL = SET_ALL;
// swaps the persons amounts of adults and juveniles
function SWAP(state) {
    var adults = state.adults, juveniles = state.juveniles;
    state.juveniles = adults;
    state.adults = juveniles;
}
exports.SWAP = SWAP;
// locks the store, can not inc/dec, exactly 2 persons fixed
function LOCK(state) {
    state.adults = 2;
    state.juveniles = 0;
    state.children = 0;
    state.locked = true;
}
exports.LOCK = LOCK;
// unlocks the store, can inc/dec again
function UNLOCK(state) {
    state.locked = false;
}
exports.UNLOCK = UNLOCK;
// resets the state of the store
function RESET_STATE(state) {
    state.adults = 2;
    state.juveniles = 0;
    state.children = 0;
    state.locked = false;
}
exports.RESET_STATE = RESET_STATE;
// export everything compliant to the vuex specification for getters
exports.default = {
    INC: INC, DEC: DEC, SET_ALL: SET_ALL, SWAP: SWAP, LOCK: LOCK, UNLOCK: UNLOCK,
    RESET_STATE: RESET_STATE
};
//# sourceMappingURL=mutations.js.map